const programmes = [
  // {
  //   id: 1,
  //   img: "https://i.ibb.co/ynCsqngM/Implementation-of-Lean-Manufacturing-Technique-at-FB-Footwear-Limited-01.jpg",
  //   companyName:
  //     "Implementation of Lean Manufacturing Technique at FB Footwear Limited”",
  // },
  // {
  //   id: 2,
  //   img: "https://i.ibb.co/9m6J8bfT/Implementing-Lean-Manufacturing-System-at-Bay-Footwear-Ltd.jpg",
  //   companyName: "Implementing Lean Manufacturing System at Bay Footwear Ltd",
  // },
  {
    id: 4,
    img: "https://i.ibb.co/5XbHTJWn/Lean-Management-Training-for-Synovia-Beximco-Pharma.jpg",
    companyName: "Lean Management Training for Synovia, Beximco Pharma",
  },
  {
    id: 6,
    img: "https://i.ibb.co/PvCmBX2X/Lean-Manufacturing-at-Dream-Zones-Uttara-Dhaka.jpg",
    companyName: "Lean Manufacturing at Dream Zones, Uttara, Dhaka",
  },
  {
    id: 8,
    img: "https://i.ibb.co/sY5jStk/Lean-Manufacturing-with-the-Students-of-14th-Batch-of-PGDPQM-at-Bangladesh-Institute-of-Management-B.jpg",
    companyName:
      "Lean Manufacturing with the Students of 14th Batch of PGDPQM at Bangladesh Institute of Management (BIM)",
  },
  {
    id: 3,
    img: "https://i.ibb.co/1J0B0CJj/Lean-Management-Training-for-Synovia-Beximco-Pharma-Batch-2.jpg",
    companyName:
      "Lean Management Training for Synovia, Beximco Pharma- (Batch 2)",
  },
  {
    id: 10,
    img: "https://i.ibb.co/9mQ6hr1Q/Lean-Six-Sigma-Training-for-Senior-Management-at-Crown-Wear-Pvt-Ltd.jpg",
    companyName:
      "Lean Six Sigma Training for Senior Management at Crown Wear Pvt Ltd.",
  },
  {
    id: 11,
    img: "https://i.ibb.co/qLQh3XfT/Lean-Six-Sigma-Yellow-Belt-program.jpg",
    companyName: "Lean Six Sigma Yellow Belt program",
  },
  {
    id: 12,
    img: "https://i.ibb.co/YThVHD1S/Productivity-and-Lean-Manufacturing-at-Accenture-Footwear-Leather-Products-Limited.jpg",
    companyName:
      "Productivity and Lean Manufacturing  at Accenture Footwear & Leather Products Limited",
  },
  {
    id: 5,
    img: "https://i.ibb.co/wZwYH8Wz/Lean-Management-Training-for-Synovia-Beximco-Pharma-1.jpg",
    companyName: "Lean Management Training for Synovia, Beximco Pharma",
  },

  {
    id: 19,
    img: "https://i.ibb.co/PzgVFW6k/Workplace-Productivity-Efficiency-Consulting-with-an-enthusiastic-team-of-ACI-Limited.jpg",
    companyName:
      "Workplace Productivity & Efficiency Training with an enthusiastic team of ACI Limited",
  },
  {
    id: 27,
    img: "https://i.ibb.co/HL7PcTdf/Lean-Manufacturing-at-BIM.jpg",
    companyName: "Lean Manufacturing at BIM",
  },
  {
    id: 28,
    img: "https://i.ibb.co/hRsTmYmd/Continuous-Improvement-at-MOET.jpg",
    companyName: "Continuous Improvement Training at Mondol Group (MOET)",
  },
  {
    id: 29,
    img: "https://i.ibb.co/Qv8g7KJX/Continuous-Improvement-Productivity-Improvement-Training-at-Apex-Footwear-Limited.jpg",
    companyName:
      "Continuous Productivity Improvement Training at Apex Footwear Limited",
  },
  {
    id: 30,
    img: "https://i.ibb.co/zWFXMprZ/Continuous-Improvement-training-at-Apex-Footwear-7th-Session.jpg",
    companyName:
      "Continuous Improvement Training  at Apex Footwear - 7th Session",
  },
  {
    id: 31,
    img: "https://i.ibb.co/pvncFwzQ/Efficiency-Improvement-Drive-at-Akij-Cement.jpg",
    companyName: "Efficiency Improvement Drive at Akij Cement",
  },
  {
    id: 32,
    img: "https://i.ibb.co/670vFSJZ/Implementation-of-LEAN-Six-Sigma-in-Apparel-manufacturing-at-BUFT.jpg",
    companyName:
      "Implementation of Lean Six Sigma in Apparel manufacturing at BUFT",
  },
  {
    id: 33,
    img: "https://i.ibb.co/7xCLdPCT/Lean-Management-with-Asrotex-Group.jpg",
    companyName: "Lean Management with Asrotex Group",
  },
  {
    id: 34,
    img: "https://i.ibb.co/pjMQqPHK/Lean-Manufacturing-at-Textile-Today.jpg",
    companyName: "Lean Manufacturing at Textile Today",
  },
  {
    id: 35,
    img: "https://i.ibb.co/1G25bhBt/Lean-Manufacturing-today-with-existing-and-future-leaders-of-Apparel-Industry.jpg",
    companyName: "Lean Manufacturing Training at Apparel Industry",
  },
  {
    id: 36,
    img: "https://i.ibb.co/21WSrNJq/Sustainable-Efficiency-Employee-Development-SEED-at-Elevate-Bangladesh.jpg",
    companyName:
      "Sustainable Efficiency & Employee Development (SEED) at Elevate Bangladesh",
  },
  {
    id: 37,
    img: "https://i.ibb.co/7xNqGnRh/Whats-App-Image-2025-05-28-at-10-05-51-74dc2033.jpg",
    companyName: "5 Day Long Lean Six Sigma Training",
  },
  {
    id: 38,
    img: "https://i.ibb.co/KpbDsL67/2-Days-Long-Lean-Manufacturing-Training-at-Comilla-Plant-of-SMC.jpg",
    companyName:
      "2 Days Long Lean Manufacturing Training at Comilla Plant of SMC",
  },
  {
    id: 39,
    img: "https://i.ibb.co/PZMDstXf/Lean-Management-at-Super-Store-Meenabazar.jpg",
    companyName: "Lean Management at Super Store- Meenabazar",
  },
  {
    id: 40,
    img: "https://i.ibb.co/1GtLKF4n/Lean-Manufacturing-at-VIVO-Mobile.jpg",
    companyName: "Lean Manufacturing at VIVO Mobile",
  },
  // {
  //   id: 7,
  //   img: "https://i.ibb.co/ymdV0D5F/Lean-Manufacturing-System-Kaizen-at-Craftsman-Footwear-Accessories-Ltd.jpg",
  //   companyName:
  //     "Lean Manufacturing System & Kaizen at Craftsman Footwear & Accessories Ltd",
  // },

  // {
  //   id: 9,
  //   img: "https://i.ibb.co/7xhTJvMX/Lean-Six-Sigma-at-YKK-Zipper.jpg",
  //   companyName: "Lean Six Sigma at YKK Zipper",
  // },

  // {
  //   id: 13,
  //   img: "https://i.ibb.co/Dgm1FKmZ/Training-on-Efficiency-Improvement-Drive-to-a-Graduating-Batch-of-Textile-Engineering-from-BGMEA-Uni.jpg",
  //   companyName:
  //     "Training on Efficiency Improvement Drive to a Graduating Batch of Textile Engineering from BGMEA University of Fashion & Technology",
  // },
  // {
  //   id: 14,
  //   img: "https://i.ibb.co/MycLZNDn/lean-s-4-01.jpg",
  // },
  // {
  //   id: 15,
  //   img: "https://i.ibb.co/ZzvvdSyx/lean-s-5-01.jpg",
  // },
  // {
  //   id: 16,
  //   img: "https://i.ibb.co/qYt9Sbgm/lean-s-6-01.jpg",
  // },
  // {
  //   id: 17,
  //   img: "https://i.ibb.co/yFdRY6pR/lean-s-7-01.jpg",
  // },
  // {
  //   id: 18,
  //   img: "https://i.ibb.co/CKy6tDGG/lean-s-8-01.jpg",
  // },
  // {
  //   id: 19,
  //   img: "https://i.ibb.co/HphLFqh8/lean-s-9-01.jpg",
  // },
  // {
  //   id: 20,
  //   img: "https://i.ibb.co/spSNHhK3/lean-s-10-01.jpg",
  // },
  // {
  //   id: 21,
  //   img: "https://i.ibb.co/C3zqnQ0t/lean-s-11-01.jpg",
  // },
  // {
  //   id: 22,
  //   img: " https://i.ibb.co/DHdQH3G6/lean-01.jpg",
  // },
  // {
  //   id: 23,
  //   img: "https://i.ibb.co/Tq1Lg8Gd/lean-02.jpg",
  // },
  // {
  //   id: 24,
  //   img: "https://i.ibb.co/G3JpKtYF/lean-03.jpg",
  // },
  // {
  //   id: 25,
  //   img: "https://i.ibb.co/BKjy4wyF/lean-04.jpg",
  // },
  // {
  //   id: 26,
  //   img: "https://i.ibb.co/7hdPZnt/lean-05.jpg",
  // },
  // {
  //   id: 27,
  //   img: "https://i.ibb.co/cSZB3VG6/lean-06.jpg",
  // },
  // {
  //   id: 28,
  //   img: "https://i.ibb.co/jZLrwthq/lean-07.jpg",
  // },
  // {
  //   id: 29,
  //   img: "https://i.ibb.co/JFSGh68j/lean-08.jpg",
  // },
  // {
  //   id: 30,
  //   img: "https://i.ibb.co/Zyy1QgP/lean-09.jpg",
  // },
  // {
  //   id: 31,
  //   img: "https://i.ibb.co/0VfWhwSN/lean-10.jpg",
  // },
  // {
  //   id: 32,
  //   img: "https://i.ibb.co/sBm9KDp/lean-11.jpg",
  // },
  // {
  //   id: 33,
  //   img: "https://i.ibb.co/gFr4t0ZK/lean-12.jpg",
  // },
  // {
  //   id: 34,
  //   img: "https://i.ibb.co/fVT93P77/lean-13.jpg",
  // },
];

export default programmes;
